import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

const StartupConsulting = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Startup <span className="breadcrumb-highlight">Consulting</span>
                                </h1>
                                <Link to="/services" style={{ textDecoration: 'none' }}>
                                    <button className="breadcrumb-btn">
                                        <span>Our Services</span>
                                        <span className="breadcrumb-arrow">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Hero Section */}
            <section className="digital-presence-hero">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="hero-badge">
                                <span className="badge-dot"></span>
                                Your Startup Success Partner
                            </div>
                            <h2 className="intro-about-heading">
                                Launch & Scale Your Startup With
                                <span className="text-gradient"> Expert Guidance</span>
                            </h2>
                            <p className="hero-description">
                                Transform your vision into reality with <span className="text-blue-highlight">comprehensive startup consulting</span> that covers everything from MVP development to market launch. We help founders navigate the complexities of building successful tech startups.
                            </p>
                            <div className="hero-buttons">
                                <button className="btn-hero-secondary">
                                    Book Free Consultation →
                                </button>
                            </div>
                            <div className="hero-stats">
                                <div className="stat-card">
                                    <h3 className="stat-number">200+</h3>
                                    <p className="stat-label">Startups Launched</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">$50M+</h3>
                                    <p className="stat-label">Funding Raised</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">85%</h3>
                                    <p className="stat-label">Success Rate</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-image-container">
                                <img src={require('../../assets/images/statup-consulting.jpg')} alt="Startup Consulting Hero" className="img-fluid rounded shadow-md" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Comprehensive Startup Services Section */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Startup Services
                        </div>
                        <h2 className="comprehensive-title">
                            End-to-End Startup Consulting Services
                        </h2>
                        <p className="comprehensive-subtitle">
                            Everything you need to launch, grow, and scale your startup successfully
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* MVP Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎯</span>
                                </div>
                                <h3 className="solution-card-title">MVP Development</h3>
                                <p className="solution-card-description">
                                    Build and launch your Minimum Viable Product quickly to validate your idea and attract early users
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Business Strategy */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📊</span>
                                </div>
                                <h3 className="solution-card-title">Business Strategy</h3>
                                <p className="solution-card-description">
                                    Develop comprehensive business plans, revenue models, and go-to-market strategies
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Product Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card highlighted">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💡</span>
                                </div>
                                <h3 className="solution-card-title">Product Development</h3>
                                <p className="solution-card-description">
                                    Full-stack product development with agile methodology and user-centric design
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Fundraising Support */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💰</span>
                                </div>
                                <h3 className="solution-card-title">Fundraising Support</h3>
                                <p className="solution-card-description">
                                    Pitch deck creation, investor connections, and fundraising strategy to secure capital
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Technology Consulting */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚙️</span>
                                </div>
                                <h3 className="solution-card-title">Technology Consulting</h3>
                                <p className="solution-card-description">
                                    Choose the right tech stack, architecture, and development approach for your startup
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Growth & Scaling */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📈</span>
                                </div>
                                <h3 className="solution-card-title">Growth & Scaling</h3>
                                <p className="solution-card-description">
                                    Growth hacking strategies, user acquisition, and scaling operations for rapid expansion
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <button className="btn-start-project">
                            Start Your Startup Journey →
                        </button>
                    </div>
                </div>
            </section>

            {/* Why Choose Profit Technologies */}
            <section className="bespoke-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <h2 className="section-main-title mb-4">
                                Why Choose Profit Technologies for Your Startup?
                            </h2>
                            <p className="section-description">
                                <strong>More Than Just Consultants - We're Your Co-Pilots</strong>
                            </p>
                            <p className="section-description">
                                At <strong>Profit Technologies</strong>, we've been in the trenches of startup building. We understand the challenges, the pivots, and the triumphs. Our team combines technical excellence with business savvy to help you avoid common pitfalls and accelerate your path to success.
                            </p>
                            <p className="section-description">
                                We've helped over 200 startups launch successfully, raise funding, and achieve product-market fit. From solo founders to funded teams, we provide hands-on support at every stage of your startup journey – from ideation to scale.
                            </p>
                            <p className="section-description">
                                <strong>What makes us the ideal startup partner:</strong>
                            </p>
                            <ul className="section-description" style={{ paddingLeft: '20px' }}>
                                <li>✓ Proven track record with 200+ successful startup launches</li>
                                <li>✓ Lean startup methodology for fast, cost-effective development</li>
                                <li>✓ Access to investor networks and funding opportunities</li>
                                <li>✓ Full-stack technical expertise across all modern technologies</li>
                                <li>✓ Flexible engagement models suited to startup budgets</li>
                                <li>✓ Ongoing mentorship and strategic guidance as you grow</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="bespoke-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80"
                                    alt="Profit Technologies Startup Consulting"
                                    className="img-fluid rounded"
                                    style={{ boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Startup Success Areas */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Industries We Serve
                        </div>
                        <h2 className="comprehensive-title">
                            Startup Expertise Across Industries
                        </h2>
                        <p className="comprehensive-subtitle">
                            Specialized knowledge in high-growth startup sectors
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* SaaS Startups */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">☁️</span>
                                </div>
                                <h3 className="solution-card-title">SaaS Platforms</h3>
                                <p className="solution-card-description">
                                    Subscription-based software solutions with scalable architecture
                                </p>
                            </div>
                        </div>

                        {/* Fintech */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💳</span>
                                </div>
                                <h3 className="solution-card-title">Fintech</h3>
                                <p className="solution-card-description">
                                    Financial technology solutions with security and compliance
                                </p>
                            </div>
                        </div>

                        {/* E-commerce */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🛒</span>
                                </div>
                                <h3 className="solution-card-title">E-commerce</h3>
                                <p className="solution-card-description">
                                    Online marketplaces and direct-to-consumer brands
                                </p>
                            </div>
                        </div>

                        {/* Healthtech */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏥</span>
                                </div>
                                <h3 className="solution-card-title">Healthtech</h3>
                                <p className="solution-card-description">
                                    Digital health solutions and telemedicine platforms
                                </p>
                            </div>
                        </div>

                        {/* Edtech */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📚</span>
                                </div>
                                <h3 className="solution-card-title">Edtech</h3>
                                <p className="solution-card-description">
                                    Educational technology and e-learning platforms
                                </p>
                            </div>
                        </div>

                        {/* AI/ML Startups */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🤖</span>
                                </div>
                                <h3 className="solution-card-title">AI/ML Solutions</h3>
                                <p className="solution-card-description">
                                    Artificial intelligence and machine learning applications
                                </p>
                            </div>
                        </div>

                        {/* Mobile Apps */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📱</span>
                                </div>
                                <h3 className="solution-card-title">Mobile Apps</h3>
                                <p className="solution-card-description">
                                    iOS and Android apps with engaging user experiences
                                </p>
                            </div>
                        </div>

                        {/* Marketplace Platforms */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏪</span>
                                </div>
                                <h3 className="solution-card-title">Marketplaces</h3>
                                <p className="solution-card-description">
                                    Two-sided platforms connecting buyers and sellers
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Startup Journey Process */}
            <section className="comprehensive-design-section py-5" style={{ backgroundColor: '#ffffff' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Process
                        </div>
                        <h2 className="comprehensive-title">
                            Your Startup Success Roadmap
                        </h2>
                        <p className="comprehensive-subtitle">
                            A proven 6-step framework from idea to successful launch
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Ideation & Validation */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💡</span>
                                </div>
                                <h3 className="solution-card-title">1. Ideation & Validation</h3>
                                <p className="solution-card-description card-text-dst">
                                    Refine your idea, validate market demand, and identify your unique value proposition
                                </p>
                            </div>
                        </div>

                        {/* Strategy & Planning */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📋</span>
                                </div>
                                <h3 className="solution-card-title">2. Strategy & Planning</h3>
                                <p className="solution-card-description card-text-dst">
                                    Create comprehensive business plan, revenue model, and go-to-market strategy
                                </p>
                            </div>
                        </div>

                        {/* MVP Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔨</span>
                                </div>
                                <h3 className="solution-card-title">3. MVP Development</h3>
                                <p className="solution-card-description card-text-dst">
                                    Build your minimum viable product with core features for early market testing
                                </p>
                            </div>
                        </div>

                        {/* Launch & Testing */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🚀</span>
                                </div>
                                <h3 className="solution-card-title">4. Launch & Testing</h3>
                                <p className="solution-card-description card-text-dst">
                                    Beta launch with early adopters, gather feedback, and iterate quickly
                                </p>
                            </div>
                        </div>

                        {/* Growth & Optimization */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📈</span>
                                </div>
                                <h3 className="solution-card-title">5. Growth & Scale</h3>
                                <p className="solution-card-description card-text-dst">
                                    Implement growth strategies, acquire users, and optimize for product-market fit
                                </p>
                            </div>
                        </div>

                        {/* Funding & Expansion */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💰</span>
                                </div>
                                <h3 className="solution-card-title">6. Funding & Expansion</h3>
                                <p className="solution-card-description card-text-dst">
                                    Secure funding, build your team, and scale operations for sustainable growth
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default StartupConsulting;
